<!-- <p-toast></p-toast> -->
<app-navbar-main *ngIf="!pathname?.includes('/order/delivery/')"></app-navbar-main>
<main class="{{ pathname?.includes('/order/delivery/') ? 'p-0' : ''}}">
  <router-outlet class="">
    <div class="circles position-relative">
      <span class="circle-1 position-absolute">

      </span>
      <span class="circle-2 position-absolute">

      </span>
    </div>
  </router-outlet>
</main>
<p-scrollTop></p-scrollTop>
@defer (prefetch on idle; on viewport) {
<app-footer *ngIf="!pathname?.includes('/order/delivery/')"></app-footer>
} @placeholder {
<div> <p-skeleton width="100%" borderRadius="16px" height="7rem"></p-skeleton></div>
}